module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/social/pinterest-b1a29cd280781dcce330ad750840917e.svg";